import { useEffect, useState } from "react";

export default function MessageToast({ message, type="success", delay=2000 }) {
    const [showMessage, setShowMessage] = useState(true);


	useEffect(() => {
		const timeOut = setTimeout(() => {
			setShowMessage(false);
		}, delay);

		return () => clearInterval(timeOut);
	}, [delay]);

	return (
		<>
        {showMessage && (
            <div className={`toast-container-${type} flex items-center justify-center max-w-5xl`}>
                <div className="font-bold text-sm">{message}</div>
            </div>
        )}
		</>
	);
}
